import React, { useEffect, useState } from "react";
import { fetchMediaBlobUrl } from "../utils/mediaUrl";

/**
 * Loads app media through authenticated REST and renders as <img>.
 * Uses the shared media blob cache — do not revoke URLs here.
 */
function AuthImage({ src, alt = "", ...props }) {
  const [blobUrl, setBlobUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;

    (async () => {
      setFailed(false);
      if (!src) {
        setBlobUrl("");
        return;
      }
      try {
        const url = await fetchMediaBlobUrl(src);
        if (active) setBlobUrl(url);
      } catch {
        if (active) {
          setBlobUrl("");
          setFailed(true);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [src]);

  if (failed || !src) return null;
  if (!blobUrl) {
    return (
      <span
        aria-hidden
        style={{
          display: "inline-block",
          width: props.width || "100%",
          minHeight: 24,
          background: "transparent",
        }}
      />
    );
  }

  return <img src={blobUrl} alt={alt} {...props} />;
}

export default AuthImage;
